import makeStrictKeysObject from "@/util/strict-keys-object.mjs";
import symbolName from "@/util/symbol-name.mjs";

export default makeStrictKeysObject({
  isViewable: symbolName("ad-is-viewable"),
  shouldRefresh: symbolName("ad-should-refresh"),
  refreshPromise: symbolName("ad-refresh-promise"),
  refreshedAt: symbolName("ad-refreshed-at"),
  refreshedCount: symbolName("ad-refresh-count"),
  lastResponse: symbolName("ad-last-response"),
});
